import {
    type App,
    type DateRange,
    GetDocumentsParams,
    GetRevenueEntriesParams,
    type RevenueEntry,
    RevenueType,
} from "@pentacode/core";

export const documentsKey = ["documents"] as const;

export function documentsQuery(app: App) {
    return {
        queryKey: [...documentsKey, "list"] as const,
        queryFn: ({ signal }: { signal: AbortSignal }) => app.api.getDocuments(new GetDocumentsParams(), { signal }),
    };
}

export function employeeDocumentsQuery(app: App, employeeId: number) {
    return {
        queryKey: [...documentsKey, "employee", employeeId] as const,
        queryFn: ({ signal }: { signal: AbortSignal }) =>
            app.api.getDocuments(new GetDocumentsParams({ employeeId }), { signal }),
    };
}

export function documentTagsQuery(app: App) {
    return {
        queryKey: [...documentsKey, "tags"] as const,
        queryFn: ({ signal }: { signal: AbortSignal }) => app.api.getDocumentTagsForCompany({ signal }),
    };
}

export const advancesKey = ["revenue-entries", "pay-advances"] as const;

export function advancesQuery(app: App, range: DateRange) {
    return {
        queryKey: [...advancesKey, range.from, range.to] as const,
        queryFn: async ({ signal }: { signal: AbortSignal }): Promise<RevenueEntry[]> =>
            (
                await app.api.getRevenueEntries(
                    new GetRevenueEntriesParams({ ...range, type: [RevenueType.PayAdvance] }),
                    { signal }
                )
            ).filter((e) => !e.draft),
    };
}
